import { useDispatch, useSelector } from 'react-redux';

import type { TypedUseSelectorHook, RootState } from 'react-redux';

export const useAppDispatch = () => useDispatch();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
